import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
  max-width: 506px;
  padding-inline: 32px;
  width: 100%;

  h1 {
    line-height: 32px;
  }
`

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`

export const AccordionContent = styled.div`
  p, ul {
    margin-left: 18px;
  }

  a {
    transition: font-weight 8ms linear;

    &:hover {
      font-weight: 500;
    }
  }

  ul {
    li {
      line-height: 24px;
    }

    li + li {
      margin-top: 8px;
    }
  }

  @media (max-width: 600px) {
    p, ul li {
      font-size: 14px;
      line-height: 20px;
    }
  }
`

export const ViewMoreButton = styled.button`
  background-color: transparent;
  border: 1px solid var(--primary);
  font-size: 14px;
  line-height: 16px;
  justify-content: center;
  padding: 9px 16px;
  height: 34px;
  width: initial;

  &:hover {
    box-shadow: none;
  }
`
